export function compareByOrderThenTitle<T>(
	a: T,
	b: T,
	orderOf: (item: T) => number | null | undefined,
	titleOf: (item: T) => string,
): number {
	const orderA = orderOf(a);
	const orderB = orderOf(b);
	const aHasOrder = orderA != null;
	const bHasOrder = orderB != null;

	if (aHasOrder && bHasOrder && orderA !== orderB) {
		return orderA - orderB;
	}

	if (aHasOrder !== bHasOrder) {
		return aHasOrder ? -1 : 1;
	}

	return titleOf(a).localeCompare(titleOf(b));
}

export function sortByOrderThenTitle<T>(
	items: T[],
	orderOf: (item: T) => number | null | undefined,
	titleOf: (item: T) => string,
): T[] {
	return [...items].sort((a, b) => compareByOrderThenTitle(a, b, orderOf, titleOf));
}
